export const TableColumnService = Symbol.for('TableColumnService');
